import { useEffect, useMemo, useCallback } from "react";

import { useSelector, useDispatch } from "react-redux";

import NewsieBottomBar from "../UploadContentNewsie/NewsiePreview/NewsieBottomBar";
import WordColumnsContainer from "../UploadContentNewsie/NewsiePreview/WordColumnsContainer";
import NewsieHeader from "../UploadContentNewsie/NewsiePreview/NewsieHeader";

import SolvedStoriesContainer from "../UploadContentNewsie/NewsiePreview/SolvedStoriesContainer";
import { addStoryToSolvedStories } from "Store/features/public/publicPuzzleSlice";
import Stopwatch from "Components/Games/Newsie/UploadContentNewsie/NewsiePreview/NewsieBottomBar/Stopwatch";
import PublicGameButtonGroup from "Components/PublicGameButtonGroup";
import { recordUserGameStat } from "API/Puzzles";
import { setPublicModal } from "Store/features/public/publicStateSlice";

import {
  declareVictory,
} from "Store/features/public/publicPuzzleSlice";

import { MODALS } from "Containers/Pages/Modal";

import "./PublicNewsie.css";

const PublicNewsie = ({ newsieGrid, takeAwayPoints, solvedStories }) => {
  const dispatch = useDispatch();
  const correctGuess = useSelector(
    (state) => state.publicPuzzleSlice.puzzle.correctGuess
  );
  const winner = useSelector((state) => state.publicPuzzleSlice.puzzle.winner);
  const victory = useSelector(
    (state) =>
      state.publicPuzzleSlice.puzzle.solvedStories?.length ===
      state.publicPuzzleSlice.puzzle.newsieInput?.length
  );
  const { time } = useSelector((state) => state.publicPuzzleSlice.puzzle.timer);
  const authToken = useSelector((state) => state.authSlice.authToken);
  const puzzleId = useSelector((state) => state.publicPuzzleSlice.puzzle.id);

  const recordGame = useCallback(async () => {
    console.log("Recording game");
    if (!winner) {
      console.log("No winner");
      if (authToken) {
        console.log("Auth token");
        recordUserGameStat(authToken, puzzleId, time, dispatch);
      }
      dispatch(declareVictory());
      dispatch(setPublicModal(MODALS.WINNER));
    }
  }, [authToken, puzzleId, dispatch, winner, time]);
  if (victory && !winner) {
    recordGame();
  }

  const puzzle = useSelector((state) => state.publicPuzzleSlice.puzzle);
  useEffect(() => {
    if (correctGuess) {
      setTimeout(() => {
        dispatch(addStoryToSolvedStories());
      }, 1000);
    }
  }, [correctGuess]);

  const className = `game-container ${
    solvedStories !== takeAwayPoints?.length ? "should-flex" : ""
  }`;
  const MemoizedStoriesContainer = useMemo(() => {
    if (solvedStories && solvedStories.length)
      return () => <SolvedStoriesContainer solvedStories={solvedStories} />;
    return () => <></>;
  }, [solvedStories]);

  return (
    <div className={className}>
      {/* <NewsieHeader /> */}
      <div className="public-newsie-header-container">
        <div className="crossword-clues-container-header">
          <b>Newsie | Time Elaped</b>
          <Stopwatch small={true} />
          <PublicGameButtonGroup />
        </div>
      </div>
      <MemoizedStoriesContainer />
      {solvedStories !== takeAwayPoints?.length && (
        <WordColumnsContainer
          isLive={true}
          newsieGrid={newsieGrid}
          correctGuess={correctGuess}
        />
      )}
      <NewsieBottomBar />
    </div>
  );
};

export default PublicNewsie;
